import { CatGridItem } from '@blocks-react/components/GridItem';
import { CatGrid } from '@blocks-react/components/Grid';
import { VideoGridProps } from '../types';
import cx from 'classnames';
import styles from '../DIY.module.scss';
import { DIYVideo } from '../diy-video';
export const VideoGrid = ({ videoLists, variant, gap }: VideoGridProps) => {
  return (
    <CatGrid variant={variant} gap={gap} data-testid="how-to-video-section">
      {videoLists?.map((item) => {
        return (
          <CatGridItem key={item.id}>
            <div className={cx('p-3', styles['cat-c-list'])}>
              <DIYVideo
                item={item}
                classname={styles['c-video-section__griditem']}
              />
            </div>
          </CatGridItem>
        );
      })}
    </CatGrid>
  );
};
